/* eslint-disable import/prefer-default-export */

import IsEmail from 'isemail';

export const isValidEmail = (email) =>
  IsEmail.validate(email, {
    minDomainAtoms: 2,
    allowUnicode: false,
  });
